import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "toast-inner" }
const _hoisted_2 = {
  key: 0,
  class: "toast-title"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  class: "toast-progress",
  ref: "progress"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "toast",
    class: _normalizeClass(["imdex-toast animated-fast fadeInUp", {
			't-success': _ctx.type == 'success',
			't-error': _ctx.type == 'error',
			't-warning': _ctx.type == 'warning'
		}])
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(_ctx.icon)
    }, null, 2),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.title != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      (_ctx.message != '')
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.message), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.destroy && _ctx.destroy(...args))),
      class: "toast-dismiss"
    }, _hoisted_5),
    _createElementVNode("div", _hoisted_6, null, 512)
  ], 2))
}